import connectivityMonitorMessages from
  'ringcentral-integration/modules/ConnectivityMonitor/connectivityMonitorMessages';

export default {
  [connectivityMonitorMessages.disconnected]: 'Se perdió la conexión de red.',
};
